import ExternalLinksBaseHandler from '../external_links_base_handler';
import ServiceFactory from '../../../../services/service_factory';
import {GNWP_SOURCES} from "../../external_links_consts";
import {MEMBERSHIP_POST_ACTIONS} from "../membership/external_links_membership_handler_consts";
import {POST_ACTIONS} from "../../../../events/post_actions";

export default class ExternalLinksPendingLoginHandler extends ExternalLinksBaseHandler {
    static CLASS = 'ExternalLinksPendingLoginHandler';
    static HandlerName = 'pending_login';

    executePostMessageAction(postMessageData) {
        if (postMessageData.Token) {
            this.close();
            ServiceFactory.create().oAuth2Service().runAutoLogin(postMessageData.Token).then(()=> {
                if(postMessageData.ActionId) {
                    switch (postMessageData.ActionId.toString()) {
                        case MEMBERSHIP_POST_ACTIONS.UPLOAD_DOCUMENTS_IV:
                            this.close(POST_ACTIONS.CLOSE);
                            ServiceFactory.create().openLinkService().openLink({source: GNWP_SOURCES.DOCUMENT_UPLOAD});
                            break;
                        default:
                            this.logger.warn('Not supported ActionID. ActionID = ' + postMessageData.ActionId);
                            break;
                    }
                }
            });
        }
    }

    getHandlerName() {
        return ExternalLinksPendingLoginHandler.HandlerName;
    }
}